import { useQuery, useQueryClient } from '@tanstack/react-query';
import { AnomalyIncidentsResponse } from '../../../models/anomaly-detection/models/AnomalyIncidentsResponse';
import { getAnomalyIncidents } from '../../../services/anomaly-detection/AnomalyIncidentService';
import { GET_ANOMALY_INCIDENTS } from '../../query/anomaly-detection/keys';

export const useGetAnomalyIncidents = (
  projectId: number | null,
  from: Date | null,
  to: Date | null,
  keywordsSet: Set<string>,
  filterChatTypes?: string[],
  enabled: boolean = true,
) => {
  const queryClient = useQueryClient();

  const keywords = Array.from(keywordsSet);

  const queryEnabled = enabled && !!projectId && !!from && !!to && keywords.length > 0;

  const queryKey = [GET_ANOMALY_INCIDENTS, projectId, from, to, keywords, filterChatTypes];

  const {
    data,
    isLoading,
    isError,
    error,
    refetch,
  } = useQuery<AnomalyIncidentsResponse>({
    queryKey,
    queryFn: () => getAnomalyIncidents(projectId!, from, to, keywords, filterChatTypes),
    staleTime: 1000 * 60 * 60 * 6,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  const incidentsByMetric = queryEnabled && data ? data : {
    brand_score: [],
    average_position: [],
  }

  return {
    brandScoreAnomalies: incidentsByMetric.brand_score,
    averagePositionAnomalies: incidentsByMetric.average_position,
    isLoading: queryEnabled ? isLoading : false,
    isError: queryEnabled ? isError : false,
    error: queryEnabled ? error : null,
    refetch,
    invalidate: () =>
      queryClient.invalidateQueries({
        queryKey,
        refetchType: 'active',
      }),
  };
};
